module.exports = __webpack_public_path__ + "img/about-02.b5a6dd8a.jpg";